import { useCallback, useEffect } from 'react';
var useOutsideClick = function (ref, callback) {
    var handleClick = useCallback(function (e) {
        if (ref.current && !ref.current.contains(e.target)) {
            callback();
        }
    }, [callback, ref]);
    useEffect(function () {
        document.addEventListener('click', handleClick, { capture: true });
        return function () {
            document.removeEventListener('click', handleClick, { capture: true });
        };
    });
};
export default useOutsideClick;
//# sourceMappingURL=useOutsideClick.js.map